//MemberViz.js

import * as THREE from "three";

import * as Color from "../classes/Color.js";

var renderColor = 0xffffff;
var renderOpacity = 0.9;
// var renderColor = 0xcc1d1d;

//------------------------------------------------------------------------
//------------------------------------------------------------------------
//									FUNCTIONS
//------------------------------------------------------------------------
//------------------------------------------------------------------------

//Functions to return meshes
//------------------------------------------------------------------------

//------------------------------------------------------------------------
//This function extrudes a slab
//------------------------------------------------------------------------
function visualizeSlab(slab) {
	// console.log("Slab from slab viz");
	// console.log(slab);

	var height;
	if (slab.material == "Steel" && slab.type == "Plate") {
		height = slab.height.height;
	} else if (slab.material == "Hybrid" && slab.type == "Plate") {
		height = slab.height.heightConcrete;
	} else {
		console.log("Else");
		height = slab.height;
	}

	// console.log("Slab height from slab viz");
	// console.log(height);

	var pts = [];

	for (let i = 0; i < slab.points.length; i++) {
		var pt = new THREE.Vector3(slab.points[i].x, slab.points[i].y, slab.points[i].z + height / 2);
		pts.push(pt);
	}

	// console.log("pts");
	// console.log(pts);

	var shape = new THREE.Shape(pts);
	var pt1 = slab.points[0];

	var startPt = new THREE.Vector3(pt1.x, pt1.y, pt1.z + height / 2);
	var endPt = new THREE.Vector3(pt1.x, pt1.y, pt1.z - height / 2);

	const path = new THREE.CatmullRomCurve3([startPt, endPt]);

	const extrudeSettings = {
		steps: 2,
		depth: height,
		bevelEnabled: false,
		bevelThickness: 0,
		bevelSize: 0,
		bevelOffset: 0,
		bevelSegments: 0,
		// extrudePath: path
	};

	// const material = new THREE.MeshBasicMaterial( { color: Color.MaterialColor.slabs, side: THREE.DoubleSide } );
	const material = new THREE.MeshLambertMaterial({ color: renderColor, side: THREE.DoubleSide });
	material.opacity = renderOpacity;
	material.transparent = true;
	// material.wireframe = true;

	const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
	// const geometry = new THREE.ShapeGeometry( shape );

	var mesh = new THREE.Mesh(geometry, material);
	return mesh;

	// return geometry;
}

//------------------------------------------------------------------------
//This function extrudes a gorundslab / the foundation
//------------------------------------------------------------------------
function visualizeFoundation(groundSlab) {
	var height = groundSlab.crossSection;

	var pts = [];

	for (let i = 0; i < groundSlab.points.length; i++) {
		var pt = new THREE.Vector3(groundSlab.points[i].x, groundSlab.points[i].y, groundSlab.points[i].z + height / 2);
		pts.push(pt);
	}

	console.log("pts");
	console.log(pts);

	var shape = new THREE.Shape(pts);
	var pt1 = groundSlab.points[0];

	var startPt = new THREE.Vector3(pt1.x, pt1.y, pt1.z + height / 2);
	var endPt = new THREE.Vector3(pt1.x, pt1.y, pt1.z - height / 2);

	const path = new THREE.CatmullRomCurve3([startPt, endPt]);

	const extrudeSettings = {
		steps: 2,
		depth: -height,
		bevelEnabled: false,
		bevelThickness: 0,
		bevelSize: 0,
		bevelOffset: 0,
		bevelSegments: 0,
		// extrudePath: path
	};

	// const material = new THREE.MeshBasicMaterial( { color:  Color.MaterialColor.foundation, side: THREE.DoubleSide } );
	const material = new THREE.MeshLambertMaterial({ color: renderColor, side: THREE.DoubleSide });
	material.opacity = renderOpacity;
	material.transparent = true;
	// material.wireframe = true;

	const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

	var mesh = new THREE.Mesh(geometry, material);
	// return mesh;

	return geometry;
}

//------------------------------------------------------------------------
//This function extrudes the shape of a bar member along its axis
//------------------------------------------------------------------------
function visualizeColumn(column, shape) {
	const path = new THREE.CatmullRomCurve3([column.start, column.end]);

	const extrudeSettings = {
		steps: 2,
		// depth: bar.distance(),
		bevelEnabled: false,
		bevelThickness: 0,
		bevelSize: 0,
		bevelOffset: 0,
		bevelSegments: 0,
		extrudePath: path,
	};

	//Basic material
	// const material = new THREE.MeshBasicMaterial( { color: Color.MaterialColor.columns, side: THREE.DoubleSide } );
	const material = new THREE.MeshLambertMaterial({ color: renderColor, side: THREE.DoubleSide });
	material.opacity = renderOpacity;
	material.transparent = true;
	// material.wireframe = true;

	//Lambert material
	// const material = new THREE.MeshLambertMaterial( { color: 0x7bb0db, side: THREE.DoubleSide } );
	// material.opacity = 0.7;
	// material.transparent = true;
	// material.wireframe = true;

	const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
	const mesh = new THREE.Mesh(geometry, material);
	// return mesh;

	return geometry;
}

//------------------------------------------------------------------------
//This function extrudes the shape of a bar member along its axis
//------------------------------------------------------------------------
function visualizeBeam(beam, shape, structSystem, slab, slabHeight) {
	var beamHeight;

	//Beams for steel material
	if (beam.material == "Steel") {
		shape = beam.crossSection.shape;
		beamHeight = beam.crossSection.profilHeight;
	}

	//Beams for concrete material
	else if (beam.material == "Concrete") {
		shape = getBeamShape(beam.crossSection);
		beamHeight = beam.crossSection.beamHeight;
	}

	//Beams for timber material
	else if (beam.material == "Timber") {
		//Beams under CLT slab
		if (structSystem == "Plate") {
			shape = getBeamShape(beam.crossSection);
			beamHeight = beam.crossSection.beamHeight;
		}
		//Beams under ribbed timber slab
		else if (structSystem == "Beam") {
			if (beam.type == "Primary") {
				shape = getBeamShape(beam.crossSection);
				beamHeight = beam.crossSection.beamHeight;
			} else if (beam.type == "Secondary") {
				shape = getBeamShapeFomRibbedTimberSlab(slab.height);
				slabHeight = 0.11;
				beamHeight = slab.height - 0.11;
			}
		}
	}

	//Beams for hybrid material
	else if (beam.material == "Hybrid") {
		if (structSystem == "Plate") {
			shape = getBeamShapeFomHBVSlab(slab.height);
			slabHeight = slab.height.heightConcrete;
			beamHeight = slab.height.heightTimber;
		} else if (structSystem == "Beam") {
			shape = beam.crossSection.shape;
			beamHeight = beam.crossSection.profilHeight;

			// console.log('shape from memb viz');
			// console.log('beamHeight from memb viz');
			// console.log(shape);
			// console.log(beamHeight);
		}
	}

	var newPathPt1 = new THREE.Vector3(beam.start.x, beam.start.y, beam.start.z - (slabHeight + beamHeight) / 2);
	var newPathPt2 = new THREE.Vector3(beam.end.x, beam.end.y, beam.end.z - (slabHeight + beamHeight) / 2);

	const path = new THREE.CatmullRomCurve3([newPathPt1, newPathPt2]);

	const extrudeSettings = {
		steps: 2,
		// depth: bar.distance(),
		bevelEnabled: false,
		bevelThickness: 0,
		bevelSize: 0,
		bevelOffset: 0,
		bevelSegments: 0,
		extrudePath: path,
	};

	// const material = new THREE.MeshBasicMaterial( { color: Color.MaterialColor.beams, side: THREE.DoubleSide } );
	const material = new THREE.MeshLambertMaterial({ color: renderColor, side: THREE.DoubleSide });
	material.opacity = 0.7;
	material.transparent = true;
	// material.wireframe = true;

	const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
	const mesh = new THREE.Mesh(geometry, material);

	// return mesh;

	return geometry;
}

//Functions to return shapes
//------------------------------------------------------------------------

//------------------------------------------------------------------------
//This function returns the shape of a column member
//------------------------------------------------------------------------
function getColumnShape(result) {
	var sideLength = result.columnSideLength;
	var vertices = [
		new THREE.Vector2(-(sideLength / 2), -(sideLength / 2)), //Pt1
		new THREE.Vector2(-(sideLength / 2), sideLength / 2), //Pt2
		new THREE.Vector2(sideLength / 2, sideLength / 2), //Pt3
		new THREE.Vector2(sideLength / 2, -(sideLength / 2)), //Pt4
		new THREE.Vector2(-(sideLength / 2), -(sideLength / 2)), //Pt5
	];
	var shape = new THREE.Shape(vertices);

	return shape;
}

//------------------------------------------------------------------------
//This function returns the shape of a beam member
//------------------------------------------------------------------------
function getBeamShape(result) {
	var height = result.beamHeight;
	var width = result.area / height;

	var vertices = [
		//Vertices for standing beam
		new THREE.Vector2(-(height / 2), -(width / 2)), //Pt1
		new THREE.Vector2(height / 2, -(width / 2)), //Pt2
		new THREE.Vector2(height / 2, width / 2), //Pt3
		new THREE.Vector2(-(height / 2), width / 2), //Pt4
		new THREE.Vector2(-(height / 2), -(width / 2)), //Pt5
	];
	var shape = new THREE.Shape(vertices);

	console.log("vertices");
	console.log(vertices);

	return shape;
}

//------------------------------------------------------------------------
//This function returns the shape of a beam member for a HBV slab
//------------------------------------------------------------------------
function getBeamShapeFomHBVSlab(result) {
	var height = result.heightTimber;
	var width = result.widthTimber;

	var vertices = [
		//Vertices for standing beam
		new THREE.Vector2(-(height / 2), -(width / 2)), //Pt1
		new THREE.Vector2(height / 2, -(width / 2)), //Pt2
		new THREE.Vector2(height / 2, width / 2), //Pt3
		new THREE.Vector2(-(height / 2), width / 2), //Pt4
		new THREE.Vector2(-(height / 2), -(width / 2)), //Pt5
	];
	var shape = new THREE.Shape(vertices);

	return shape;
}

//------------------------------------------------------------------------
//This function returns the shape of a beam member for a ribbed timber slab
//------------------------------------------------------------------------
function getBeamShapeFomRibbedTimberSlab(result) {
	console.log("result from getBeamShapeFomRibbedTimberSlab");
	console.log(result);

	var plateHeight = 0.11; //Plate height = 11 cm
	var ribHeight = result - plateHeight;
	var ribWidth = 0.14; //Rib width = 14 cm

	var vertices = [
		//Vertices for standing beam
		new THREE.Vector2(-(ribHeight / 2), -(ribWidth / 2)), //Pt1
		new THREE.Vector2(-(ribHeight / 2), ribWidth / 2), //Pt2
		new THREE.Vector2(ribHeight / 2, ribWidth / 2), //Pt3
		new THREE.Vector2(ribHeight / 2, -(ribWidth / 2)), //Pt4
		new THREE.Vector2(-(ribHeight / 2), -(ribWidth / 2)), //Pt5
	];
	var shape = new THREE.Shape(vertices);

	return shape;
}

//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { visualizeSlab, visualizeFoundation, visualizeColumn, visualizeBeam, getColumnShape, getBeamShape, getBeamShapeFomHBVSlab, getBeamShapeFomRibbedTimberSlab };
